import * as React from 'react';
import * as I18n from 'i18n-js';
import * as elog from '@reverbdotcom/commons/dist/elog';
import { trackView } from '@reverbdotcom/commons/dist/tracker';
import AlertBox from '@reverbdotcom/commons/dist/components/alert_box';

export interface IProps {
  redirectUrl: string;
  paReq: string;
  md: string;
  termUrl: string;
  submitForm?: () => void;
  show3ds1AlertBox?: boolean;
}

const redirectTimeoutMs = 2000;

const TAG = 'adyen.threeds1_container';

export default class ThreeDS1Container extends React.Component<IProps, {}> {
  formRef?: HTMLFormElement;

  static defaultProps: Partial<IProps> = {
    show3ds1AlertBox: true,
    submitForm() {
      this.formRef.submit();
    },
  };

  componentDidMount() {
    trackView({ componentName: 'ThreeDS1Container' });
    elog.info(`${TAG}.mount`);

    setTimeout(
      this.props.submitForm.bind(this),
      redirectTimeoutMs,
    );
  }

  renderAlert() {
    if (!this.props.show3ds1AlertBox) { return null; }
    return (
      <AlertBox color="blue">
        <h1 className="align-center">
          {I18n.t('discovery.coreOnboarding.beingRedirectedFor3ds')}
        </h1>
      </AlertBox>
    );
  }

  render() {
    return (
      <form action={this.props.redirectUrl} method="POST" ref={(el) => { this.formRef = el; }}>
        {this.renderAlert()}
        <input type="hidden" name="PaReq" value={this.props.paReq} />
        <input type="hidden" name="MD" value={this.props.md} />
        <input type="hidden" name="TermUrl" value={this.props.termUrl} />
      </form>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/threeds1_container.tsx